import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgendamentoDespesaAppRoutingModule } from './agendamento-despesa.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AgendamentoDespesaAppRoutingModule
  ]
})
export class AgendamentoDespesaAppModule { }
